<template>
  <div class="content">
    <DataReportSelect selectTabsType="audienceData" @event-filter="fetchData">
      <span slot="audienceData">
        <div class="btn-group-wrap">
          <div></div>
          <el-button :loading="loadingExport"  style="display: flex; justify-items: center; align-items: center" size="mini"  @click="fetchData('export')">
                    <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
                  </el-button>
          </div>
        <div class="charts-warp">
          <div class="charts-container">
            <template v-if="chartDataList.length > 0">
              <el-row :gutter="16">
                <template v-for="(item,index) in chartDataList">
                  <div :key="index">
                    <el-col :span="item.policyId === 489 ?  12:item.policyId === 183 ? 12:6">
                      <ContentBox :title="item.policyName" style="height:342px">
                        <template v-if="item.policyId !== 489 && item.policyId !== 183">
                          <ve-ring
                            :data="item.ringChartsData"
                            :loading="loading"
                            :legend="ringcharts.legend"
                            :settings="ringcharts.settings"
                            :extend="ringcharts.extend"
                          >
                            <ChartDataEmpty
                              v-if="!loading && item.ringChartsData.rows.length === 0"
                            />
                          </ve-ring>
                        </template>
                        <template v-else>
                          <VeHistogram
                            :data="item.ringChartsData"
                            :loading="loading"
                            :settings="histogram.settings"
                            :extend="histogram.extend"
                          >
                            <ChartDataEmpty
                              v-if="!loading && item.ringChartsData.rows.length === 0"
                            />
                          </VeHistogram>
                        </template>
                      </ContentBox>
                    </el-col>
                  </div>
                </template>
              </el-row>
            </template>
            <template v-else>
              <div style="height:calc(100vh - 202px) ">
                <ChartDataEmpty style="right:16px;left:16px;bottom:16px" />
              </div>
            </template>
          </div>
        </div>
      </span>
    </DataReportSelect>
  </div>
</template>
<script>
import DataReportSelect from '@/components/DataReportSelect'
import ChartDataEmpty from '@/components/ChartDataEmpty'
import VeRing from 'v-charts/lib/ring.common'
import VeHistogram from 'v-charts/lib/histogram.common.js'
import 'echarts/lib/component/legendScroll'
import 'v-charts/lib/style.css'
import downLoad from '@/utils/downLoad';
// import 'echarts/lib/component/grid'
// import 'echarts/lib/component/title'
export default {
  inject: ['searchData'],
  components: {
    DataReportSelect,
    VeRing,
    ChartDataEmpty,
    VeHistogram
  },
  data() {
    return {
      loadingExport: false,
      ringcharts: {
        extend: {
          tooltip: {
            confine: true
          }
        },
        legend: {
          show: false
        },
        settings: {
          radius: ['25%', '44%'],
          offsetY: '120px',
          labelLine: {
            legend: 100
          }
        }
      },
      histogram: {
        extend: {
          tooltip: {
            confine: true
          },
          color: ['#1890FF'],
          legend: {
            show: false
          },
          grid: {
            top: '2%',
            bottom: '40%'
          },
          yAxis: {
            splitLine: {
              lineStyle: { type: 'dashed' }
            }
          },
          xAxis: {
            axisLabel: {
              interval: 0,
              rotate: 40
            }
          }
        },
        settings: {
          yAxisType: ['percent']
        }
      },
      chartDataList: [],
      loading: false
      // screenWidth: document.documentElement.clientWidth,
      // sortHeight: 76
    }
  },
  methods: {
    handleExport() {
      this.loading = false
      let form = JSON.parse(JSON.stringify(this.searchData.model))
      form.beginDate = this.$moment(this.searchData.time[0]).format(
        'YYYY-MM-DD'
      )
      form.endDate = this.$moment(this.searchData.time[1]).format(
        'YYYY-MM-DD'
      )
      form.pageSize = 20000
      form.pageNo = 1
      this.loadingExport = true
      const options = {
        url: 'api/dsp/report/exportCrowdExcel',
        data: form
      }
      downLoad(options)
        .then(res => {
          this.loadingExport = false
        })
        .catch(() => {
          this.loadingExport = false
        })
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTableData()
    },
    fetchData(type) {
      if (this.searchData.model.orderId) {
        this.loading = true
        let form = JSON.parse(JSON.stringify(this.searchData.model))
        form.beginDate = this.$moment(this.searchData.time[0]).format(
          'YYYY-MM-DD'
        )
        form.endDate = this.$moment(this.searchData.time[1]).format(
          'YYYY-MM-DD'
        )
        if (type === 'export') {
          this.handleExport()
          return
        }
        this.$service.getCrowdReport(form).then(data => {
          if (data) {
            this.chartDataList = []
            for (let i = 0; i < data.crowdAnalysisList.length; i++) {
              this.chartDataList.push({
                policyName: data.crowdAnalysisList[i].policyName,
                policyId: data.crowdAnalysisList[i].policyId,
                ringChartsData: {
                  columns: [],
                  rows: []
                }
              })
              this.chartDataList[i].ringChartsData.columns = [
                data.crowdAnalysisList[i].policyName,
                'pv'
              ]
              for (
                let j = 0;
                j < data.crowdAnalysisList[i].crowdList.length;
                j++
              ) {
                this.chartDataList[i].ringChartsData.rows.push({
                  [data.crowdAnalysisList[i].policyName]:
                    data.crowdAnalysisList[i].crowdList[j].crowdName,
                  pv: data.crowdAnalysisList[i].crowdList[j].ratio
                })
              }
            }
            let orderSort = [487, 181, 489, 183, 182, 490, 185, 188, 189, 191]
            this.chartDataList = this.chartDataList.sort(function (a, b) {
              // let orderSort = [191, 189, 188, 185, 490, 182, 183, 489, 181, 487]
              if (orderSort.indexOf(a.policyId) === -1) {
                orderSort.push(a.policyId)
              }
              return (
                orderSort.indexOf(a.policyId) - orderSort.indexOf(b.policyId)
              )
            })
            // this.chartDataList = list
            setTimeout(() => {
              this.loading = false
            }, 300);
          }
        })
      }
    }
  },
  created() {
    if (this.searchData.isFilter) {
      this.fetchData()
    }
  }
}
</script>
<style lang="stylus" scoped>
.btn-group-wrap {
  display flex
  justify-content: space-between
  padding 10px 32px
  margin-bottom 16px
  background #ffffff
  text-align right
}
.content {
  height: calc(100vh - 60px);
  position: relative;
}

.header-serach {
  position: relative;
}

.charts-warp {
  // height calc(100vh - 202px)
  display: flex;
  flex: 1;
  // overflow auto
}

.charts-container {
  width: 100%;
  height: 100%;
  margin: 0 16px;
}

p {
  margin: 0px;
}

.title {
  font-size: 16px;
  font-weight: 500;
}

.chart-area {
  display: flex;
  flex-direction: row;
}

.chart-area > div {
  width: 50% !important;
}

.no-message {
  text-align: center;
  height: 300px;
}
</style>
